import {Component, EventEmitter, Output} from '@angular/core';
import {SubBudgetModel} from '../models/sub-budget';
import {GeneratedBy} from '../../interfaces';
import {FormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {CommonModule} from '@angular/common';


@Component({
  selector: 'app-sub-budget-form',
  templateUrl: './sub-budget-form.component.html',
  styleUrls: ['./sub-budget-form.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ]
})
export class SubBudgetFormComponent {

  model = new SubBudgetModel('', GeneratedBy.User);
  @Output() onSubmit = new EventEmitter<SubBudgetModel>();

  onFormSubmit() {
    this.onSubmit.emit(this.model);
  }

}
